{
  "version": 1,
  "asset_id": "c0bbd8e0-6fe8-4011-86d7-30a626795684",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/c0bbd8e0-6fe8-4011-86d7-30a626795684/cover-400.webp",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/c0bbd8e0-6fe8-4011-86d7-30a626795684/cover-400.webp",
  "original_filename": "cover-400.webp",
  "size": 15372,
  "content_type": "image/webp",
  "created_at": "2026-06-25T01:16:01Z"
}
